export function filterData(data = [], filters = {}) {
  if (!filters || Object.keys(filters).length === 0) return data;

  return data.filter((row) => {
    return Object.entries(filters).every(([key, value]) => {
      if (key === "search" || value === null || value === undefined || String(value).trim() === "") return true;

      const cell = row[key];

      if (cell === null || cell === undefined) return false;

      return String(cell)
        .toLowerCase()
        .includes(String(value).toLowerCase());
    });
  });
}
